import { useMemo } from "react";
import { Text, Tooltip } from "@chakra-ui/react";
import { fetchLanguagesExcerpt } from "network/helper";
import { LanguagesExcerptWithToggleProps } from "../types";

export function LanguagesExcerptWithToggle({ value }: LanguagesExcerptWithToggleProps) {
  const languageList = useMemo(() => {
    return String(value || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }, [value]);

  if (languageList.length <= 1) {
    return <>{languageList[0] || "-"}</>;
  }

  const excerptText = fetchLanguagesExcerpt(languageList.join(","));
  const fullText = languageList.join(", ");

  return (
    <Tooltip
      hasArrow
      placement="bottom-start"
      bg="#fff"
      color="#0B0E10"
      border="1px solid #E5E7EB"
      borderRadius="12px"
      p="10px 12px"
      maxW="420px"
      label={
        <Text fontSize="14px" color="#0B0E10" whiteSpace="normal">
          {fullText}
        </Text>
      }
    >
      <span style={{ 
        cursor: 'pointer', 
        textDecoration: 'underline dotted',
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
        display: 'inline',
        whiteSpace: 'nowrap'
      }}>
        {excerptText}
      </span>
    </Tooltip>
  );
}
